import { createFileRoute } from '@tanstack/react-router';
import { TwilioInbox } from '@/features/omnichannel-twilio/components/TwilioInbox';

export const Route = createFileRoute('/_authenticated/omnichannel-twilio')({
  component: OmnichannelTwilioInboxPage,
});

function OmnichannelTwilioInboxPage() {
  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-3xl font-bold">Omnicanal (Twilio) — Caixa de Entrada</h1>
        <p className="text-muted-foreground mt-1">
          Ponte temporária via Twilio enquanto a integração oficial da Meta está
          em análise.
        </p>
      </div>
      <TwilioInbox />
    </div>
  );
}
